export default "__VITE_ASSET__ByWrbfhi__"